<template>
  <div class="w-full mt-12">
    <div
      class="w-full flex justify-start h-20 top-0 pl-4 md:pl-10 pt-8 fixed bg-white z-10 cursor-pointer"
      @click="$router.push('login')"
    >
      <logo-icon />
    </div>
    <div class="w-full flex justify-center">
      <div
        class="w-full mt-6 md:pt-4 flex justify-center item-center mx-2 md:w-441px"
      >
        <o-card class="w-full mx-2">
          <div class="md:p-4">
            <span class="flex justify-center font-bold text-xl my-4"
              >Recover Password</span
            >
            <el-form
              @keyup.enter.native="validateForm('recoverPasswordForm')"
              label-position="top"
              class="my-6"
              :model="recoverPasswordForm"
              ref="recoverPasswordForm"
              :rules="rules"
              label-width="80px"
              size="normal"
            >
              <el-form-item label="New password" prop="password">
                <el-input
                  name="password"
                  placeholder="min. 8 characters"
                  show-password
                  type="password"
                  v-model="recoverPasswordForm.password"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="mt-8"
                label="Confirm Password"
                prop="confirmPassword"
              >
                <el-input
                  name="confirmPassword"
                  placeholder="Re-type Password"
                  type="password"
                  show-password
                  v-model="recoverPasswordForm.confirmPassword"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <o-button
                  class="text-white"
                  :loading="isLoading"
                  @click="validateForm('recoverPasswordForm')"
                >
                  Recover</o-button
                >
              </el-form-item>
              <p
                class="flex justify-center text-lg lg:text-normal cursor-pointer"
                @click="$router.push('forgot-password')"
              >
                cancel
              </p>
            </el-form>
          </div>
        </o-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recoverPassword',
  data () {
    var regularExpression =
      /^(?=.*[A-Za-z.])(?=.*\d)(?=.*[@#?!@$%^&*-.])[A-Za-z\d.#?!@$%^&*-]{8,}$/
    var validateNewPassword = (rule, value, callback) => {
      if (!regularExpression.test(value)) {
        callback(
          new Error(
            'Should contain atleast one number, one capital letter and one special character'
          )
        )
      } else {
        callback()
      }
    }
    var validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'))
      } else if (value !== this.recoverPasswordForm.password) {
        callback(new Error("Password inputs don't match!"))
      } else {
        callback()
      }
    }
    return {
      rules: {
        password: [
          {
            required: true,
            message: 'Please input your password',
            trigger: ['blur', 'change']
          },
          {
            min: 8,
            message: 'password must be at least 8 characters long',
            trigger: ['blur', 'change']
          },
          { validator: validateNewPassword, trigger: ['blur', 'change'] }
        ],
        confirmPassword: [
          {
            validator: validateConfirmPassword,
            trigger: ['blur', 'change'],
            required: true
          }
        ]
      },
      recoverPasswordForm: {
        password: '',
        confirmPassword: ''
      },
      isLoading: false
    }
  },
  methods: {
    validateForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.resetPassword()
        } else {
          this.$notify.error({
            title: 'Password required',
            message: 'Please input your new password',
            position: 'top-right'
          })
        }
      })
    },
    resetPassword () {
      const vm = this
      this.isLoading = true
      this.$store
        .dispatch('auth/resetPassword', {
          ...this.recoverPasswordForm,
          code: this.$route.query.code,
          userID: this.$route.query.userID
        })
        .then((res) => {
          this.$swal({
            icon: 'success',
            title: 'Password has been successfully reset',
            confirmButtonText: 'Proceed to login',
            iconColor: this.$primaryColor,
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: 'login' }).catch(() => {})
            }
          })
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: err,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  components: {
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  }
}
</script>

<style scoped>
>>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
>>> .el-input__inner {
  border-radius: 8px;
  border-color: #c7c8d2;
  height: 48px;
}
>>> .el-card__body {
  padding: 10px;
}
>>> .el-form-item__label,
>>> .el-form-item__content {
  line-height: 16px;
  font-size: 12px;
  font-weight: 600;
}
</style>
